















































































































































































import { defineComponent } from '~/utils/nuxt3-migration'
import { ciAngleDown } from '~/icons/source/regular/angle-down'
import { formatNumber } from '~/utils/number'
import { useUserAgent } from '~/compositions/user-agent'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    minAmount: {
      type: [String, Number],
      required: true
    },
    maxAmount: {
      type: [String, Number],
      required: true
    },
    minInstallments: {
      type: [String, Number],
      required: true
    },
    maxInstallments: {
      type: [String, Number],
      required: true
    },
    interestRate: {
      type: [String, Number],
      required: true
    },
    fixedInterestRate: {
      type: Boolean,
      required: false
    },
    bankText: {
      type: String,
      required: false,
      default: ''
    },
    iconColorClass: {
      type: String,
      required: false,
      default: 'tw-text-primary'
    },
    bank: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup() {
    const { isMobile } = useUserAgent()
    return {
      ciAngleDown,
      formatNumber,
      isMobile
    }
  },
  i18n: defineComponentTranslations({
    fixed_interest_from: {
      en: 'Fixed interest rate from',
      el: 'Σταθερό επιτόκιο από'
    }
  })
})
